import { useEffect, useState } from "react";
import useDataBean from "../../../core/services/dataBean/useDataBean";
import { Singleton } from "../../../core/services/Singleton";
import { toast } from "react-toastify";
import { ListMenu } from "../../theme/Component/ListMenu";
import { BasicPage } from "../../theme/Component/BasicPage";
import { BasicTable } from "../../theme/Component/BasicTable";
import { Modal } from "../../theme/Component/Modal";
import { ModalConfirm } from "../../theme/Component/ModalConfirm";
import { _AgreementBalance, _ContractModifyType } from "../../../core/services/dataBean/EntityCatalogVdos";
import { BasicSwitch } from "../../theme/Component/BasicSwitch";





export const ContractModifyType = () => {

    const modifytipe = useDataBean(_ContractModifyType);

    const single = Singleton.getInstance();
    const [lista, setLista] = useState<any>([]);
    const [beneficiario, setbeneficiario] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [cronograma, setcronograma] = useState<any>({ name: 'cronograma', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modal, setModal] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: '', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });
    const [swich, setSwich] = useState<boolean>(null)



    useEffect(() => {
        getLista()

    }, [])


    const getLista = () => {

        modifytipe.instance.getContractModifyTypeCatalogPorPropiedades({ State: 1 }, null).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp)
                }

            }
        )

    }



    const create = () => {
        modifytipe.setBean({
            State: 1,
            IDEmployee: single.getAccountID(),
            Since: single.getCurrenDate(),
            ModifyBudget: false
        });
        setSwich(false);
        setModal({ ...modal, "view": true });
    }

    const editaItem = () => {
        //console.log(Project.bean);
        modifytipe.update().then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }
    const deleteItem = () => {
        modifytipe.bean.State = 2;
        //console.log(Project.bean);
        editaItem();
        setModalC({ ...modalC, "view": false });

    }




    const head = [
        { title: 'ID', property: 'IDContractModifyType', visible: true },
        { title: 'Nombre', property: 'Name', visible: true },
        { title: 'Modifica Presupuesto', property: 'ModifyBudget', visible: true },
        { title: 'Reduce Valor', property: 'SumaValue', visible: true },
        { title: 'Descripción', property: 'Description', visible: true },
        { title: 'Fecha', property: 'Since', visible: true },
    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [

            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModal({ ...modal, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },


        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }


    return (
        <BasicPage titulo="Tipos de modificaciones contractuales">
            <div className="row">

                <div className="col-md-12">

                    <BasicTable body={lista} head={head} rowSet={modifytipe.setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem}></BasicTable>
                    <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                        <>
                            <div className="row">


                                <div className="col-md-12">
                                    <label>Nombre</label>
                                    <input name="Name" className="form-control" value={modifytipe.bean.Name} onChange={modifytipe.handleChange} />
                                </div>
                                <div className="col-md-6">
                                    <BasicSwitch label="Modifica Presupuesto ?" estado={modifytipe.bean.ModifyBudget} eventChange={(e: any) => { modifytipe.setBean({ ...modifytipe.bean, "ModifyBudget": e }) }}></BasicSwitch>
                                </div>
                                <div className="col-md-6">
                                    <BasicSwitch label="Reduce valor ?" estado={modifytipe.bean.SumaValue} eventChange={(e: any) => { modifytipe.setBean({ ...modifytipe.bean, "SumaValue": e }) }}></BasicSwitch>
                                </div>
                                <div className="col-md-12">
                                    <label>Descripción</label>
                                    <textarea name="Description" className="form-control" value={modifytipe.bean.Description} onChange={modifytipe.handleChange} />
                                </div>

                            </div>

                        </>
                    </Modal>


                    <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                        <strong>Eliminar item</strong>
                    </ModalConfirm>
                </div>

            </div>
        </BasicPage>
    )
}